import { Filters } from 'containers/FiltersProducts/components/Filters';
import { Flex, Typography } from 'front-commons/ds';
import useDrawer from 'stores/drawer';
import { FiltersProductsMobileProps } from './interfaces';
import { ButtonClose } from './styles';
import { Icon } from 'hype-ds';

export function FiltersProducts({ filters, extrasFilters }: FiltersProductsMobileProps) {
	const { handleCloseAllDrawers } = useDrawer();

	return (
		<Flex direction="column" height="100%" justifyContent="space-between" gap="0">
			<Flex padding="24px 24px 0 24px" direction="column" overflow="auto">
				<Flex justifyContent="space-between" width="100%">
					<Flex gap="8px">
						<Icon name="filter_list" size="24px" />
						<Typography variant="Paragraph/Semibold">Filtrar</Typography>
					</Flex>

					<ButtonClose variant="none" onClick={handleCloseAllDrawers}>
						<Icon name="close" size="16px" />
					</ButtonClose>
				</Flex>

				<Filters filters={filters || []} extrasFilters={extrasFilters} />
			</Flex>
		</Flex>
	);
}
